<template>
    <div class="phone" :class="$attrs.class">
        <div class="shopopee-chat-iframe-box">
            <div class="operation-part">
                <phoneTitleComponent
                    @goBack="returnFunc"
                    :obj="titleObj"
                    @clickChatFunc="goChatView"
                    :showChatBtn="displayView !== 'chat'"
                />
            </div>
            <div :class="displayBottomView ? 'content-part-with-bottom' : 'content-part'">
<!--                <iframe v-show="displayView === 'chat'" ref="chatRoomIframeDom" :src="chatRoomUrl" seamless="seamless"></iframe>-->
                <div v-show="displayView === 'login'" style="width: 100%; margin: 0 auto; max-width: 560px; height: calc(100% - 40px); padding-top: 40px; overflow-y: auto; box-sizing: border-box;">
                    <loginComponent @login-check-complete="loginCheck"/>
                </div>

                <!--            <div v-show="displayView === 'card'" style="width: 100%; height: 100%;">-->
                <div v-if="displayView === 'card'" style="width: 100%;height: 100%;overflow-y: auto;overflow-x: hidden;">
                    <cardDemo
                        :cardId="cardId"
                        :isAllow="isAllow"
                        :userLogin="userinfo.login"
                        :fullScreen="false"
                        @sendMaterialChat="goMaterialChat"
                    />
                </div>

                <div v-if="displayView === 'account'" style="width: 100%;">
                    <accountComponent @logout-complete="logoutCheck"/>
                </div>

                <div v-if="displayView === 'mycard'" style="width: 100%; height: 100%;padding: 5px;box-sizing: border-box;">
                    <myCardView :useChat="false" :usePageHeader="false" />
                </div>

                <div v-if="displayView === 'material'" style="width: 100%; height: 100%;">
                    <shopMaterialGroup :companycode="companycodeMaterial"/>
                </div>

                <div v-if="displayView === 'img'" style="width: 100%; height: 100%">
                    <phoneImgComponent :imgSrc="displayImgSrc"/>
                </div>

                <div v-if="displayView === 'index'" style="width: 100%; height: 100%">
<!--                    <phoneIndexComponent @go-other-view="goViewBack"/>-->
                    <HomeView :fullScreen="false" @go-other-view="goViewBack" />
                </div>

                <div v-if="displayView === 'setting'" style="width: 100%; height: 100%">
                    <settingComponent @openGuide="showGuide" @clickAudio="clickAudio" @logout-complete="logoutCheck" />
                </div>

<!--                <div v-if="displayView === 'shopSearch'" style="width: 100%; height: 100%">-->
<!--                    <searchShopComponent @goShop="goShopPosition" />-->
<!--                </div>-->

<!--                <div v-if="displayView === 'materialSearch'" style="width: 100%; height: 100%">-->
<!--                    <searchMaterialComponent @goShop="goShopPosition" />-->
<!--                </div>-->

                <div v-if="(displayView === 'materialSearch' || displayView === 'shopSearch') && searchTag === 'shop'" style="width: 100%; height: 100%; ">
                    <searchMainComponent
                        :type="searchTypeTag"
                        @goShop="goShopPosition"
                    />
                </div>

                <div v-if="(displayView === 'materialSearch' || displayView === 'shopSearch') && (searchTag === 'hall' ||searchTag === 'hallSearch')"  style="width: 100%; height: 100%">
                    <searchHallMainComponent @goShop="goShopPosition" />
                </div>

                <div v-if="displayView === 'myCompany'" style="width: 100%; height: 100%">
                    <div style="width: calc(100% - 30px); height: 100%; margin: auto;">
                        <myCompany />
                    </div>

                </div>

                <div v-if="displayView === 'myBill'" style="width: 100%; height: 100%">
                    <myBill />
                </div>

                <div v-if="displayView === 'record5Editor'" style="width: 100%; height: 100%">
                    <div style="width: calc(100% - 30px); margin: auto; margin-top: 15px;">
                        <record5Editor />
                    </div>
                </div>

                <div v-if="displayView === 'cardRecommend'" style="width: 100%; height: 100%">
                    <div style="max-width: 768px; margin: auto; margin-top: 15px;">
                        <cardRecommendView :code="cardCompanycode" />
                    </div>
                </div>

                <div v-if="displayView === 'cardEditor'" style="width: 100%; height: 100%">
                    <cardEditorView :fullScreen="true" />
                </div>

<!--                <div v-if="displayView === 'cardEditor'" style="width: 100%; height: 100%">-->
<!--                    <cardEditorView :fullScreen="false" />-->
<!--                </div>-->

                <div v-if="displayView === 'myQuotation'" style="width: 100%; height: 100%">
                    <el-scrollbar>
                        <myQuotation
                            :fullScreen="false"
                            :showReturnBtn="false"
                        />
                    </el-scrollbar>
                </div>

              <div v-if="displayView === 'myHallOrder'" style="width: 100%; height: 100%">
                <el-scrollbar>
                  <myHallOrder
                      :fullScreen="false"
                      :showReturnBtn="false"
                  />
                </el-scrollbar>
              </div>

                <div v-if="displayView === 'productQuotation'" style="width: 100%; height: 100%">
<!--                    <el-scrollbar>-->
                        <quotationMain :fullScreen="false" :companycode="quotationCompanyCode"/>
<!--                    </el-scrollbar>-->

                </div>

                <div v-if="displayView === 'shop'" style="width: 100%; height: 100%">
                    <!--                    <el-scrollbar>-->
                    <div style="max-width: calc(100% - 40px); height: 100%; margin: auto; margin-top: 15px;">
                        <ShopControllerView
                            :useTitle="false"
                            :showReturnBtn="false"
                            :fullScreen="false"
                        />
                    </div>

                    <!--                    </el-scrollbar>-->

                </div>

                <div v-if="displayView === 'mallManager'" style="width: 100%; height: 100%">
                    <MallManager
                        :fullScreen="false"
                    />
                </div>

                <div v-if="displayView === 'islandManager'" style="width: 100%; height: 100%">
                    <IslandManager
                        :fullScreen="false"
                    />
                </div>

                <div v-if="displayView === 'hall'" style="width: 100%; height: 100%; padding: 10px; box-sizing: border-box;">
                    <el-scrollbar>
                        <HallManager
                            :showReturnBtn="false"
                        />
                    </el-scrollbar>
                </div>

              <div v-if="displayView === 'materialEditor'" style="width: 100%; height: 100%; padding: 10px; box-sizing: border-box;">
                <el-scrollbar>
                  <MaterialEditor
                      @clickReturnBtn="returnFunc"

                  />
                </el-scrollbar>
              </div>

            </div>

            <div class="operation-part" v-show="displayBottomView">
                <phoneBottomComponent />
            </div>
        </div>
        <!--other begin-->

<!--        <div class="volume"></div>-->
<!--        <div class="power"></div>-->

        <!--        <div class="camera"></div>-->

<!--        <div class="receiver">-->
<!--            <div></div>-->
<!--        </div>-->

        <!--other end-->

    </div>

</template>

<script setup>
    import {getCurrentInstance, onMounted, onUnmounted, ref, computed, provide, watch, inject, nextTick} from 'vue'
    import loginComponent from '@/components/loginComponent.vue'
    import cardDemo from '@/views/cardDemo.vue'
    import accountComponent from '@/components/accountComponent.vue'
    import shopMaterialGroup from '@/components/shopMaterialGroup.vue'
    import phoneImgComponent from '@/components/phoneImgComponent.vue'
    import phoneIndexComponent from '@/components/phoneIndexComponent.vue'
    import phoneTitleComponent from '@/components/phoneTitleComponent.vue'
    import phoneBottomComponent from "@/components/phoneBottomComponent.vue"
    import settingComponent from '@/components/phone/settingComponent.vue'
    import searchMainComponent from '@/components/phone/searchMainComponent.vue'
    import searchHallMainComponent from "@/components/phone/hall/searchHallMainComponent"
    import quotationMain from "@/views/quotationMain"
    import myQuotation from "@/views/myQuotation"
    import record5Editor from "@/components/shopopee/record5/record5Editor"
    import cardRecommendView from "@/views/cardRecommendView"
    import myCardView from "@/views/myCardView"
    import myCompany from "@/views/myCompany"
    import myBill from "@/views/myBill"
    import cardEditorView from "@/views/cardEditorView"
    import HomeView from "@/views/HomeView.vue";
    import ShopControllerView from "@/views/shopControllerView.vue";
    import MallManager from "@/components/shopopee/mall/mallManager.vue";
    import IslandManager from "@/components/shopopee/island/islandManager.vue";
    import HallManager from "@/components/shopopee/hall/hallManager.vue";
    import { useUserinfo } from '@/stores/userinfo'
    import chatApi from "@/request/chatApi";
    import myUtil from "@/util/util";
    import MyHallOrder from "@/views/myHallOrder.vue";
    import MaterialEditor from "@/components/shopopee/material/materialEditor.vue";

    const { proxy } = getCurrentInstance();
    const userinfo = useUserinfo()

    const i18n = inject("i18n")

    const emits = defineEmits(['exec-command-complete', 'login-complete', 'goShopPosition', "newShop","clickAudio"])

    const pageMap = {
        'chat': {
            name: "Chat",
            hasBack: true
        },
        'login': {
            name: i18n.tkey("lang_login"),
            hasBack: false
        },
        'mycard': {
            name: i18n.tkey("lang_my_memberwork"),
            hasBack: true
        },
        'card': {
            name: i18n.tkey("lang_memberwork"),
            hasBack: true
        },
        'account': {
            name: i18n.tkey("lang_my_account"),
            hasBack: true
        },
        'materialSearch': {
            // name: "產品搜索",
            // name: i18n.tkey("lang_search_text"),
            name: "3DShopopee TV",
            hasBack: false
        },
        'shopSearch': {
            // name: "店鋪搜索",
            // name: i18n.tkey("lang_search_text"),
            name: "3DShopopee TV",
            hasBack: false
        },
        'index': {
            // name: i18n.tkey("lang_my_phone"),
            name: "3DShopopee",
            hasBack: false
        },
        'setting': {
            name: i18n.tkey("lang_setting"),
            hasBack: true
        },
        'myCompany': {
            name: i18n.tkey("lang_company_info"),
            hasBack: true
        },
        'myBill': {
            name: i18n.tkey("lang_bill"),
            hasBack: true
        },
        "record5Editor": {
            name: i18n.tkey("lang_company_news_info"),
            hasBack: true,
            backViewFunc: goMyCardView
        },
        "cardRecommend": {
            name: i18n.tkey("lang_company_news_info"),
            hasBack: true,
        },
        "cardEditor": {
            name: i18n.tkey("lang_card_editor"),
            hasBack: false,
        },
        "myQuotation": {
            name: i18n.tkey("lang_my_quotation"),
            hasBack: true,
        },
        "myHallOrder":{
          name: i18n.tkey("lang_my_hall_order"),
          hasBack: true,
        },
        "productQuotation": {
            name: i18n.tkey("lang_get_quo_price"),
            hasBack: true,
        },
        "shop": {
            name: i18n.tkey("lang_my_3D_shop"),
            hasBack: true,
        },
        "mallManager": {
            name: i18n.tkey("lang_mall_manage"),
            hasBack: true,
        },
        "islandManager": {
            name: i18n.tkey("lang_island_manage"),
            hasBack: true,
        },
        "hall": {
            name: i18n.tkey("lang_hall_manager_1"),
            hasBack: true,
        },
      "materialEditor": {
        name: i18n.tkey("lang_product_manager"),
        hasBack: false,
      }
    }

    //登錄後要執行的方法
    let loginReadyFunc = null
    //聊天iframe是否已就緒
    let chatIframeReadyFlag = false
    //聊天iframe就緒後要執行的方法
    let chatReadyFunc = null

    const titleObj = computed(() => {
        if (null != pageMap[displayView.value]){
            return pageMap[displayView.value]
        }else{
            return { name: "", hasBack: true }
        }
    })

    const displayView = ref("login")
    const displayBottomView = ref(false)
    const chatRoomUrl = ref(null)
    const cardId = ref(null)
    const cardCompanycode = ref(null)
    const quotationCompanyCode = ref(null)
    const isAllow = ref(false)
    const companycodeMaterial = ref(null)
    const displayImgSrc = ref(null)
    //搜索內容的類別 店鋪或者展館
    const searchTag = ref("shop")
    //首页搜索内容的类别
    const searchTypeTag = ref(null)

    // watch(() => displayView.value, (newValue, oldValue) => {
    //     if (newValue === "mycard"){
    //         displayBottomView.value = true
    //     }else{
    //         displayBottomView.value = false
    //     }
    // })

    function loginCheck(status) {
        //status 登錄狀態 -1登錄成功 0未登錄
        if (status === -1){
            chatRoomUrl.value = `${proxy.$ShopopeeUrl}/enterChatRoom?login=${userinfo.login}&password=${userinfo.password}&tag=3dshopopee`
            // chatRoomUrl.value = `${proxy.$ShopopeeUrl}/liveChat?tag=3dshopopee`
            displayView.value = "index"
            // displayView.value = "mycard"

            if (null != loginReadyFunc && typeof loginReadyFunc === "function"){
                const func = loginReadyFunc
                loginReadyFunc = null

                if (chatIframeReadyFlag){
                    func()
                }else {
                    chatReadyFunc = func
                }

            }
        }

        emits("login-complete")
    }

    function clickAudio() {
        emits('clickAudio')
    }

    async function openPersonChat(login, flag) {
        if (null == userinfo.token){
            displayView.value = "login"

            loginReadyFunc = () => {
                openPersonChat(login, flag)
            }

            emits("exec-command-complete", "openPersonChat", 0)
            return
        }

        const request = chatApi.openPersonalRoom
        const params = request.getParams()

        params.token = userinfo.token
        params.users[0].account = login

        request.send(params, (res) => {
            const datas = {
                roomid: res.data,
            }

            if (flag){
                datas.goMaterialFlag = true
            }

            proxy.$refs.chatRoomIframeDom.contentWindow.postMessage({ type: 'goUserRoom',  data: datas }, '*')
            emits("exec-command-complete", "openPersonChat", -1)
            displayView.value = "chat"
        })

    }

    function goCardView(id, value){
        if (userinfo.memberStatus === 0){
            displayView.value = "login"
        }else{
            cardId.value = id
            isAllow.value = value

            if (displayView.value === "card"){
                displayView.value = ""
                nextTick(() => {
                    displayView.value = "card"
                })
            }else{
                displayView.value = "card"
            }
        }

        emits("exec-command-complete", "goCardView")
    }

    function goCompanyView(){
        if (userinfo.memberStatus === 0){
            displayView.value = "login"
        }else{
            displayView.value = "myCompany"
        }
    }

    function goBillView(){
        if (userinfo.memberStatus === 0){
            displayView.value = "login"
        }else{
            displayView.value = "myBill"
        }
    }

    function goRecord5Editor() {
        if (userinfo.memberStatus === 0){
            displayView.value = "login"
        }else{
            displayView.value = "record5Editor"
        }
    }

    async function goMaterialChat(login, url){
        if (null == userinfo.token){
            displayView.value = "login"

            emits("exec-command-complete", "goMaterialChat", 0)
            return
        }

        const request = chatApi.openPersonalRoom
        const params = request.getParams()

        params.token = userinfo.token
        params.users[0].account = login

        request.send(params, (res) => {
            proxy.$refs.chatRoomIframeDom.contentWindow.postMessage({ type: 'goUserRoomAndMessage',  data: {roomId: res.data, message: url} }, '*')
            displayView.value = "chat"
        })

        emits("exec-command-complete", "goMaterialChat", -1)
    }

    function goLoginView() {
        displayView.value = "login"

        emits("exec-command-complete", "goLoginView")
    }

    function goAccountView() {
        displayView.value = "account"

        emits("exec-command-complete", "goAccountView")
    }

    function goMaterialView(companycode) {
        if (null != companycode){
            companycodeMaterial.value = companycode

            displayView.value = "material"

            emits("exec-command-complete", "goMaterialView")
        }
    }

    function goDisplayImgView(src) {
        if (null != src){
            displayImgSrc.value = src

            displayView.value = "img"

            emits("exec-command-complete", "goDisplayImgView")
        }
    }

    function goDisplayIndexView() {
        goIndexView()

        emits("exec-command-complete", "goDisplayIndexView")
    }

    function goIndexView(){
        displayView.value = "index"
    }

    function goSearchView(tag) {
        if (myUtil.isEmpty(tag)){
            searchTypeTag.value = null
        }else{
            searchTypeTag.value = tag
        }

        if (displayView.value === "shopSearch"){
            displayView.value = null

            nextTick(() => {
                displayView.value = "shopSearch"
            })

        }else{
            displayView.value = "shopSearch"
        }

        emits("exec-command-complete", "goSearchView")
    }

    function goMyCardView() {
        if (displayView.value === "mycard"){
            displayView.value = ""

            setTimeout(() => {
                displayView.value = "mycard"

                emits("exec-command-complete", "goMyCardView")
            }, 150)
        }else{
            displayView.value = "mycard"

            emits("exec-command-complete", "goMyCardView")
        }
    }

    function logoutCheck(){
        chatRoomUrl.value = null

        chatIframeReadyFlag = false
        chatReadyFunc = null

        displayView.value = "login"
    }

    function goViewBack(name){
        if (null != pageMap[name]){
            displayView.value = name
        }else{
            if (name == "newShop"){
                emits("newShop")
            }else if (name == 'returnShopopee'){
                emits("returnShopopee")
            }
        }
    }

    function goShopPosition(wa, siojournal, islandid){
        emits("goShopPosition", wa, siojournal, islandid)
    }

    function showGuide(){
        emits("goThreeGuide")
    }

    function handleChatMsgEvent(e){
        chatIframeReadyFlag = true

        if (e.data.type == 'chatReady'){
            if (null != chatReadyFunc && typeof chatReadyFunc === "function"){
                const func = chatReadyFunc
                chatReadyFunc = null
                func()
            }
        }else{
            handleChatIframeEvent(e)
        }

    }

    function returnFunc(){
        if (null != pageMap[displayView.value].backViewFunc && typeof pageMap[displayView.value].backViewFunc === "function"){
            pageMap[displayView.value].backViewFunc()
        }else{
            goIndexView()
        }
    }

    function goCardRecommend(code){
        cardCompanycode.value = code

        displayView.value = "cardRecommend"
    }

    function goProductQuotation(code) {
        quotationCompanyCode.value = code

        displayView.value = "productQuotation"
        emits("exec-command-complete", "openPersonChat", -1)
    }

    function goChatView(){
        emits("exec-command-complete", "openPersonChat", -1)
        displayView.value = "chat"
    }

    function goMyQuotation() {
        displayView.value = "myQuotation"
    }

    function goMaterialEditor() {
      displayView.value = "materialEditor"
    }
    function goMyHallOrder(){
        displayView.value = "myHallOrder"
    }

    function goCardEditorView(){
        displayView.value = "cardEditor"
        // proxy.$router.push({name: "cardEditor"})
    }

    function handleChatIframeEvent(e){

        if (e.data.type == "goProductQuotation"){
            goProductQuotation(e.data.data)
        }
    }

    function goShopControlView(){
        displayView.value = "shop"
    }

    onMounted(() => {

        if (proxy.$route.path.indexOf("/hall") != -1){
            searchTag.value = "hall"
        }else if (proxy.$route.path.indexOf("/hallSearch") != -1){
            searchTag.value = "hallSearch"
        }

        window.addEventListener("message", handleChatMsgEvent)
    })

    onUnmounted(() => {
        window.removeEventListener("message", handleChatMsgEvent)
    })

    provide('phoneView', {
        openPersonChat,
        goCardView,
        goCompanyView,
        goBillView,
        goRecord5Editor,
        goCardRecommend,
        goMyCardView,
        goCardEditorView,
        goProductQuotation,
        goMyQuotation,
        goMyHallOrder,
        goShopControlView,
        goMaterialEditor
    })

    defineExpose({
        openPersonChat,
        goCardView,
        goLoginView,
        goAccountView,
        goMaterialView,
        goDisplayImgView,
        goDisplayIndexView,
        goSearchView,
        goMyCardView,
        goChatView,
        goProductQuotation,
        goShopControlView,
        goMaterialChat,
        goMaterialEditor
    })
</script>

<style scoped>
    .shopopee-chat-iframe-box {
        z-index: 20;
        position: relative;
        height: 100%;
        overflow-x: hidden;
        /*overflow-y: auto;*/
        overflow-y: hidden;
        width: calc(100% + 10px);
        left: -5px;
        //border-radius: 35px;
        background: #fff;
    }

    .shopopee-chat-iframe-box .operation-part {
        width: 100%;
        height: 50px;
    }

    .shopopee-chat-iframe-box .content-part {
        position: relative;
        height: calc(100% - 50px);
        overflow-x: hidden;
        /*overflow-y: auto;*/
        overflow-y: hidden;
        /*width: calc(100% + 10px);*/
        width: 100%;
        background: #fff;
    }

    .shopopee-chat-iframe-box .content-part-with-bottom {
        position: relative;
        height: calc(100% - 100px);
        overflow-x: hidden;
        /*overflow-y: auto;*/
        overflow-y: hidden;
        /*width: calc(100% + 10px);*/
        width: 100%;
        background: #fff;
    }

    .shopopee-chat-iframe-box .bottom-part {
        width: 100%;
        height: 50px;
    }

    .shopopee-chat-iframe-box iframe {
        width: calc(100% + 2px);
        /*height: calc(100% + 163px);*/
        height: calc(100%);
        border: none;
        margin-left: -1px;
    }

    @media screen and (min-width: 520px) {
        .phone {
            position: absolute;
            left: 0;
            top: 0;
            /*width: 400px;*/
            width: 100%;
            /*height: 800px;*/
            height: 100%;
            /*margin-left: -200px;*/
            margin-left: 0;
            //border: 20px solid #000;
            //border-radius: 60px;
            transition: all 1.5s ease;
        }

        .phone:before {
            //content: "";
            //position: absolute;
            /*width: 421px;*/
            //width: calc(100% + 21px);
            /*height: 815px;*/
            //height: calc(99% + 21px);
            //box-shadow: 0 0 24px #fff;
            //border-radius: 45px;
            //left: -10px;
            //top: -8px;
        }

        .phone:after {
            //content: "";
            //position: absolute;
            /*width: 382px;*/
            //width: calc(20% - 18px);
            /*height: 751px;*/
            //height: calc(40% - 49px);
            //border: 16px solid #19191d;
            //background: #19191d;
            //border-top: 30px solid #19191d;
            //border-bottom: 30px solid #19191d;
            //border-radius: 41px;
            //left: -6px;
            //top: -6px;
        }
    }

    @media screen and (max-width: 520px) {
        .phone {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            //margin-left: -45%;
            //border: 20px solid #000;
            //border-radius: 60px;
            transition: all 1.5s ease;
        }

        .phone:before {
            //content: "";
            //position: absolute;
            //width: calc(100% + 21px);
            //height: calc(100% + 15px);
            //box-shadow: 0 0 24px #fff;
            //border-radius: 45px;
            //left: -10px;
            //top: -8px;
        }

        .phone:after {
            //content: "";
            //position: absolute;
            //width: calc(40% - 18px);
            //height: calc(40% - 49px);
            //border: 16px solid #19191d;
            //background: #19191d;
            //border-top: 30px solid #19191d;
            //border-bottom: 30px solid #19191d;
            //border-radius: 41px;
            //left: -6px;
            //top: -6px;
        }
    }

    .box {
        position: absolute;
        border: #19191d 1px solid;
        width: 423px;
        height: 817px;
        left: -12px;
        top: -10px;
        z-index: 9;
        border-radius: 50px;
        box-shadow: #2e2c2c 0 0 14px;
    }

    .box:before {
        content: "";
        position: absolute;
        width: 410px;
        height: 789px;
        border-radius: 50px;
        top: 10px;
        left: 6px;
        z-index: -1;
        background-size: 100%;
        background-position: bottom;
        background-image: linear-gradient(45deg, #46a7c0 50%, #185c92 50%, #185c92 100%);
    }

    .volume {
        width: 9px;
        height: 100px;
        border: #000 1px solid;
        background: linear-gradient(#8c8c8c, #000 9%, #222, #000 94%, #353535 100%);
        position: absolute;
        right: -25px;
        top: 125px;
        z-index: -1;
        border-radius: 20px;
    }

    .power {
        width: 9px;
        height: 46px;
        border: #000 1px solid;
        background: linear-gradient(#8c8c8c, #000 9%, #222, #000 94%, #353535 100%);
        position: absolute;
        right: -25px;
        top: 260px;
        z-index: -1;
        border-radius: 20px;
    }

    .receiver {
        position: absolute;
        top: -13px;
        left: 50%;
        margin-left: -50px;
        background: #000000;
        border: #484848 1px solid;
        width: 100px;
        height: 8px;
        z-index: 9;
        border-radius: 20px;
    }

    .receiver ul {
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        margin: 1px;
        justify-content: space-around;
    }

    .receiver ul li {
        background: #303030;
        width: 1px;
        height: 1.5px;
        float: left;
        transform: skewX(-38deg);
    }

    .camera {
        position: absolute;
        width: 22px;
        height: 22px;
        background: #19191d;
        border-radius: 100%;
        top: 10px;
        left: 20px;
        z-index: 9;
    }


    .receiver div {
        width: 100px;
        height: 8px;
    }

    .receiver div:after {
        content: "";
        display: block;
        width: 95%;
        height: 83%;
        top: 1px;
        left: 3px;
        position: absolute;
        background-repeat: no-repeat;
        background-image: repeating-linear-gradient(to right, #434242, #000000 1px, rgba(255, 255, 255, 0) 1px, rgba(255, 255, 255, 0) 3px), repeating-linear-gradient(to right, #434242, #19191d 1px, rgba(255, 255, 255, 0) 1px, rgba(255, 255, 255, 0) 3px);
        background-size: 100% 50%;
        background-position: 0 0, 2px 4px;
        transform: skew(-25deg);
    }
</style>